import BaseServiceCrud from './BaseServiceCrud';

export default class NotificationService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'notifications';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            hideExpired : criteria.hideExpired,
            title: criteria?.title,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publishToCompanies(id, request) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}/companies`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    get(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element, lang, elementId) {
        window.console.log(elementId)
        return this.fetch(`${this.domain}/${this.path}/${lang}/${elementId}`,  {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    removeNotification(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

}
